import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export type SubmissionSource = "contact" | "ai_intake";

export class Submission extends HasProjectMixin(Model) {
  declare id: number;
  declare board: number;
  declare site: number;
  declare source: SubmissionSource;
  declare name: string;
  declare email: string;
  declare phone: string;
  declare message: string;
  declare additionalNotes: string;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "Submission";
  }

  static get fields() {
    return [
      "id",
      "board",
      "site",
      "source",
      "name",
      "email",
      "phone",
      "message",
      { name: "additionalNotes", dataSource: "additional_notes" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
Submission.exposeProperties();
